import { Button } from '@mui/material';
import { Routes } from 'constants/pages';
import * as React from 'react';
import { useIsMutating } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AvailableCompany } from 'services/clients/user';
import { Company } from './Company';

interface Props {
  companies: AvailableCompany[];
}

export const CompanyList: React.FC<Props> = (props) => {
  const { companies } = props;
  const navigate = useNavigate();

  const isMutating = useIsMutating(['joinCompany']) > 0;

  const handleCreate = React.useCallback(() => {
    navigate(Routes.CreateCompany);
  }, [navigate]);

  const companyRows = React.useMemo(
    () =>
      companies.map((company) => (
        <Company
          company={company}
          suggested={company.source === 'domain'}
          key={company.id}
          disabled={isMutating}
        />
      )),
    [companies, isMutating]
  );

  return (
    <div className="space-y-4">
      {companyRows}
      <Button
        fullWidth
        variant="outlined"
        color="info"
        onClick={handleCreate}
        disabled={isMutating}
      >
        + Create new company instead
      </Button>
    </div>
  );
};
